import dynamic from "next/dynamic";

export const DynamicContent019 = dynamic(() => import("./Content019"), {
  suspense: true,
});
